import { render, staticRenderFns } from "./Polygon.vue?vue&type=template&id=1e774895&scoped=true&"
import script from "./Polygon.vue?vue&type=script&lang=js&"
export * from "./Polygon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e774895",
  null
  
)

export default component.exports